import { type ReactNode } from 'react';
import type { Creator } from '@/types';
import { useAppealLead, useUserDeleteLead } from '../hooks/use-creator-fase-b';
import { CreatorAppealConfirm } from './creator-appeal-confirm';
import { CreatorUserDeleteConfirm } from './creator-user-delete-confirm';
import type { DetailMode } from './creator-detail-sections';

type SectionProps = {
  creator: Creator;
  setMode: (m: DetailMode) => void;
  onClose: () => void;
};

export function AppealSection({
  creator,
  setMode,
  onClose,
}: SectionProps): ReactNode {
  const appeal = useAppealLead();
  return (
    <div className="mt-base">
      <CreatorAppealConfirm
        onConfirm={(description) =>
          appeal.mutate({ id: creator.id, description }, { onSuccess: onClose })
        }
        onCancel={() => setMode('view')}
        isPending={appeal.isPending}
        serverError={appeal.descriptionError}
      />
    </div>
  );
}

export function UserDeleteSection({
  creator,
  setMode,
  onClose,
}: SectionProps): ReactNode {
  const userDel = useUserDeleteLead();
  return (
    <div className="mt-base">
      <CreatorUserDeleteConfirm
        onConfirm={(reason) =>
          userDel.mutate({ id: creator.id, reason }, { onSuccess: onClose })
        }
        onCancel={() => setMode('view')}
        isPending={userDel.isPending}
      />
    </div>
  );
}
